import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Submitted", -1)

import {  } from 'vue';

    

export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationSubmitted',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { density: "compact" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(" Your application has been submitted. If you chose to register, you can return to the Application Status page at any point to check the status of your application. ")
    ]),
    _: 1
  }))
}
}

})